export default __webpack_public_path__ + "static/media/brax.30ad2084.svg";